import React from 'react';
import { Shield, ShieldCheck, Plug, Zap } from 'lucide-react';

export const StatusStrip = () => (
  <div className="h-8 border-t border-border bg-card text-muted-foreground text-[11px] flex items-center px-4 gap-5">
    <div className="flex items-center gap-1.5">
      <span className="status-dot bg-primary" />
      <span className="uppercase tracking-wider">Environment: Prototype</span>
    </div>
    <div className="flex items-center gap-1.5">
      <Plug className="h-3 w-3 text-info" />
      <span>Integration mode: <span className="badge-mock !text-[10px]">Mock</span></span>
    </div>
    <div className="flex items-center gap-1.5">
      <ShieldCheck className="h-3 w-3 text-success" />
      <span>Compliance engine: <span className="text-success font-medium">Enabled</span></span>
    </div>
    <div className="flex items-center gap-1.5">
      <Zap className="h-3 w-3 text-warning" />
      <span>Latency p95: <span className="font-mono-num">312ms</span></span>
    </div>
    <div className="ml-auto flex items-center gap-1.5">
      <Shield className="h-3 w-3 text-primary" />
      <span>PDPL masking active • SAMA / NCA placeholders shown</span>
    </div>
  </div>
);

export default StatusStrip;
